import React from "react";
import { useState } from "react";
import CommonDescription from "../../../../CommonComponents/CommonDescription";
import { peerReviewApi } from "../../../../Services/caseManagement.service";
import useToaster from "../../../../customHook/useToaster";

function PeerReview({ caseId = 0, onSuccess = () => {} }) {
  const [inputText, setInputText] = useState("");
  const { showToast } = useToaster();
  const inputChangeHandler = (e) => {
    setInputText(e.target.value);
  };
  const submitHandler = () => {
    let review = inputText?.trim();
    if (!review) return showToast("Please provide review.", "warning", true);
    let payload = {
      caseId,
      review,
    };
    peerReviewApi(payload)
      ?.then((response) => {
        if (response?.success) {
          showToast(response?.message, "success", true);
          onSuccess();
        }
      })
      ?.catch((err) => {
        showToast(err?.response?.message, "error", true);
      });
  };

  return (
    <div>
      <CommonDescription
        minRows={6}
        isHeadingHidden={true}
        placeholder="Enter Review"
        onChange={inputChangeHandler}
        isSubmitActive={inputText?.length}
        onSubmitButton={submitHandler}
        descriptionVal={inputText}
      />
    </div>
  );
}

export default PeerReview;
